import { action, observable } from 'mobx'

export interface IUserStore {
  age?: number
  gender?: string
  price?: number
  weight?: number
  consumptionDays: number[]
  showResults: boolean

  resetUserStoreFromStepIndex(index: number): void
  setAge(age: number): void
  setGender(gender: string): void
  setPrice(price: number): void
  setWeight(weight: number): void
  setConsumptionDays(days: number[]): void
  setShowResults(show: boolean): void
  reset(): void
}

export class ClassUserStore implements IUserStore {
  @observable public age = null
  @observable public gender = null
  @observable public price = null
  @observable public weight = null
  @observable public consumptionDays: number[] = []
  @observable public showResults = false

  @action public setGender(gender: string): void {
    this.gender = gender
  }

  @action public setAge(age: number): void {
    this.age = age
  }

  @action public setPrice(price: number): void {
    this.price = price
  }

  @action public setWeight(weight: number): void {
    this.weight = weight
  }

  @action public setConsumptionDays(selectedDays: number[]): void {
    this.consumptionDays = selectedDays
  }

  @action public resetUserStoreFromStepIndex(index: number): void {
    switch (index) {
      case 1:
        this.gender = ''
        break
      case 2:
        this.age = null
        break
      case 3:
        this.weight = null
        break
      case 4:
        this.consumptionDays = []
        break
      case 6:
        this.price = null
        break
      default:
        break
    }
  }

  @action public setShowResults(show: boolean): void {
    this.showResults = show
  }

  @action public reset(): void {
    this.age = null
    this.gender = ''
    this.price = null
    this.weight = null
    this.consumptionDays = []
    this.showResults = false
  }
}

export const UserStore = new ClassUserStore()



// WEBPACK FOOTER //
// ./src/store/UserStore.ts